module.exports = __webpack_public_path__ + "img/my-clock-in-empty.071cfbaf.png";